// extracted by mini-css-extract-plugin
export default {"center":"SwitchButton_center__jeAkN","formcontrolDiv":"SwitchButton_formcontrolDiv__JaFUa","hsText":"SwitchButton_hsText__G0SDX"};